import { useContext } from "react";
import MainSectionSection from "../../components/MainSectionSection";
import SectionTitle from "../../components/SectionTitle";
import MerchantContext from "../../contexts/MerchantContext";
import RecaudoWizard from "../../components/recaudo/RecaudoWizard";
import { Spinner } from "@/components/ui/spinner";

const RecaudoContainer = (): JSX.Element => {
  const { merchantId, isLoading } = useContext(MerchantContext);

  if (isLoading) {
    return (
      <MainSectionSection gap="24px">
        <div className="flex min-h-[300px] items-center justify-center">
          <Spinner size="xl" />
        </div>
      </MainSectionSection>
    );
  }

  if (!merchantId) {
    return (
      <MainSectionSection gap="24px">
        <SectionTitle title="Recaudo" />
        <div className="flex min-h-[200px] items-center justify-center">
          <p className="text-gray-600">No se encontró el negocio.</p>
        </div>
      </MainSectionSection>
    );
  }

  return (
    <MainSectionSection gap="24px">
      <SectionTitle title="Recaudo" />
      <RecaudoWizard merchantId={merchantId} />
    </MainSectionSection>
  );
};

export default RecaudoContainer;
